const BASE = "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold";

const MAP = {
  actief: "bg-emerald-100 text-emerald-700",
  inactief: "bg-slate-200 text-slate-700",
  gepland: "bg-blue-100 text-blue-700",
  "in-uitvoering": "bg-amber-100 text-amber-700",
  "wacht-op-materiaal": "bg-orange-100 text-orange-700",
  afgerond: "bg-emerald-100 text-emerald-700",
  open: "bg-rose-100 text-rose-700",
  "in-behandeling": "bg-violet-100 text-violet-700",
  hoog: "bg-rose-100 text-rose-700",
  normaal: "bg-blue-100 text-blue-700",
  laag: "bg-slate-200 text-slate-700",
  waarschuwing: "bg-amber-100 text-amber-700",
  "let-op": "bg-orange-100 text-orange-700",
  compliance: "bg-cyan-100 text-cyan-700",
};

export default function StatusBadge({ value }) {
  const normalized = String(value || "").toLowerCase();
  const color = MAP[normalized] || "bg-slate-100 text-slate-700";

  return <span className={`${BASE} ${color}`}>{value || "Onbekend"}</span>;
}
